module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/banco/banco.component.css
// module id = ./src/app/banco/banco.component.css
// module chunks = main